/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCartBuyAgain = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.22 4H2V2h3.78l2.75 11h8.716l2-7h2.08l-2.572 9H9.031l.25 1H18v2H7.72L4.22 4zM9.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
        fill="currentcolor"
      />
      <path
        d="m13.086 6-1.293-1.293 1.414-1.414L16.914 7l-3.707 3.707-1.414-1.414L13.086 8H9.5V6h3.586z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCartBuyAgain as CartBuyAgain };
